import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'reactstrap';
import { clearModal } from '@shoflo/studio-redux/actions';
import ModalHeader from 'components/Modal/Header';

import {
  StyledModalBody,
  StyledParagraph
} from 'components/ActiveStream/ActiveStream.styled';
import { ACTIVE_STREAM_MODAL } from 'constants/ModalTypes';
import ActiveStreamsList from 'containers/pages/Broadcast/ActiveStreamList';

const title = 'Heads up, you have an active stream!';
const description = `Before you go, we wanted to let you know that this Studio currently has
the following stream(s) actively running and will continue to run until
you manually stop them, or until they automatically end.`;

const ActiveStreamModal = () => {
  const dispatch = useDispatch();

  const onModalClose = () => dispatch(clearModal(ACTIVE_STREAM_MODAL));
  const isModalOpen = useSelector(
    ({ modal }) => modal && modal.type === ACTIVE_STREAM_MODAL
  );
  const activeStreams = useSelector(({ modal }) => modal && modal.initialValue);
  let filteredActiveStreams = [];

  if (activeStreams && Array.isArray(activeStreams)) {
    filteredActiveStreams = activeStreams.filter(f => f.title);
  }

  const redirectToEventDash = () => {
    const { teamId, eventId, referralUrl } = activeStreams.pop();

    if (referralUrl) {
      window.location.assign(referralUrl);
    } else {
      window.location.assign(`/dash/team/${teamId}/event/${eventId}/dashboard`);
    }
  };

  return (
    <Modal
      isOpen={isModalOpen}
      toggle={onModalClose}
      data-testid="active-stream-modal"
    >
      <ModalHeader>{title}</ModalHeader>
      <StyledModalBody>
        <StyledParagraph>{description}</StyledParagraph>
        <ActiveStreamsList
          streams={filteredActiveStreams}
          redirectToEventDash={redirectToEventDash}
          onModalClose={onModalClose}
        />
      </StyledModalBody>
    </Modal>
  );
};

export default ActiveStreamModal;
